import PropTypes from 'prop-types';
import styled from 'styled-components';
import { RADIUS } from '../radius/radius';
import {
  COLOR_BACKGROUND_PRIMARY as COLOR_BACKGROUND,
  COLOR_TEXT_DISABLED as COLOR_DISABLED,
  COLOR_TEXT_PRIMARY as COLOR_PRIMARY_FALLBACK,
} from '../colors/colors';

const StyledPrimaryButton = styled.button`
  width: 100%;
  max-width: 420px;
  padding: 16px 24px;
  border: none;
  border-radius: ${RADIUS.SM};
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  background: ${({ $primaryColor }) => $primaryColor || COLOR_PRIMARY_FALLBACK};
  color: ${({ $textButtonColor }) => $textButtonColor || COLOR_BACKGROUND};
  margin-top: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.5;
    background: ${COLOR_DISABLED};
    cursor: not-allowed;
  }

  &:active {
    transform: scale(0.98);
  }
`;

const StyledOutlinedButton = styled.button`
  width: 100%;
  max-width: 420px;
  padding: 16px 24px;
  border: 1px solid
    ${({ $primaryColor }) => $primaryColor || COLOR_PRIMARY_FALLBACK};
  border-radius: ${RADIUS.SM};
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  background: transparent;
  color: ${({ $primaryColor }) => $primaryColor || COLOR_PRIMARY_FALLBACK};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const YouPrimaryButton = ({
  children,
  primaryColor,
  textButtonColor,
  ...rest
}) => (
  <StyledPrimaryButton
    $primaryColor={primaryColor}
    $textButtonColor={textButtonColor}
    {...rest}
  >
    {children}
  </StyledPrimaryButton>
);

YouPrimaryButton.propTypes = {
  children: PropTypes.node,
  primaryColor: PropTypes.string,
  textButtonColor: PropTypes.string,
};

export const YouOutlinedButton = ({
  children,
  primaryColor,
  // eslint-disable-next-line no-unused-vars
  textButtonColor,
  ...rest
}) => (
  <StyledOutlinedButton $primaryColor={primaryColor} {...rest}>
    {children}
  </StyledOutlinedButton>
);

YouOutlinedButton.propTypes = {
  children: PropTypes.node,
  primaryColor: PropTypes.string,
  textButtonColor: PropTypes.string,
};
